import type { AccessMenu } from 'commons/modules/access-by-menu';
import type { OptionTab } from './models/option-tab';
import { TAB_GROUPS } from './constants';

export const getCurrentOption = (currentPath: string) => {
  for (const group of TAB_GROUPS) {
    const currentOption = group.find((option) => option.path === currentPath);
    if (currentOption) {
      return currentOption;
    }
  }
  return null;
};

export const findTabsByCurrentPath = (currentPath: string) => {
  for (const itemTabs of TAB_GROUPS) {
    if (!itemTabs) continue;
    const foundTab = itemTabs.find((item) => item.path === currentPath);
    if (foundTab) {
      return itemTabs;
    }
  }
  return [];
};

export const propagateExclusiveByOfficeToTabs = (
  tabs: OptionTab[],
  accessByMenu: AccessMenu[],
): OptionTab[] => {
  return tabs.map((tab) => {
    if (!tab.screenKey) {
      return tab;
    }

    // Find the screen in accessByMenu by screenKey
    for (const menu of accessByMenu) {
      const screen = menu.screens.find((s) => s.screenKey === tab.screenKey);
      if (screen?.exclusiveByOffice) {
        return {
          ...tab,
          exclusiveByOffice: screen.exclusiveByOffice,
        };
      }
    }

    return tab;
  });
};
